import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import BookingButton from "../components/BookingButton";

const MainLayout = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow container mx-auto px-4 py-6">{children}</main>
      <Footer />
      <BookingButton />      
    </div>
    
  );

};
console.log("Rendering MainLayout");

export default MainLayout;